module.exports = __webpack_public_path__ + "img/goipcap-min.25276404.jpg";